/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipient_BothInputs */

const en_recipient_both = /** @type {(inputs: Recipient_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const he_recipient_both = /** @type {(inputs: Recipient_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שניהם`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {Recipient_BothInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recipient_both = /** @type {((inputs?: Recipient_BothInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipient_BothInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recipient_both(inputs)
	return he_recipient_both(inputs)
});